import { Crown } from "lucide-react";

export const FanChoiceIcon = ({ size = "md", className = "", testId = "fan-choice-icon" }) => {
  const s = { sm: ["w-5 h-5", "w-3 h-3"], md: ["w-7 h-7", "w-4 h-4"], lg: ["w-11 h-11", "w-6 h-6"] }[size];
  return (
    <span
      data-testid={testId}
      aria-hidden="true"
      className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-purple-900/80 to-fuchsia-900/60 ring-1 ring-amber-300/50 shadow-[0_0_14px_rgba(217,70,239,0.55),0_0_4px_rgba(251,191,36,0.5)] shrink-0 ${s[0]} ${className}`}
    >
      <Crown className={`${s[1]} text-amber-300 fill-amber-400/90 drop-shadow-[0_0_3px_rgba(251,191,36,0.8)]`} strokeWidth={2} />
    </span>
  );
};
